import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-other-plans-details',
  templateUrl: './other-plans-details.component.html',
  styleUrls: ['./other-plans-details.component.scss']
})
export class OtherPlansDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
